import { render, staticRenderFns } from "./StockWindow.vue?vue&type=template&id=26d8a455&"
import script from "./StockWindow.vue?vue&type=script&lang=js&"
export * from "./StockWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26d8a455')) {
      api.createRecord('26d8a455', component.options)
    } else {
      api.reload('26d8a455', component.options)
    }
    module.hot.accept("./StockWindow.vue?vue&type=template&id=26d8a455&", function () {
      api.rerender('26d8a455', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/bigtex/StockWindow.vue"
export default component.exports